export default {
    lineOptions: [
        {
            label: 'Ja',
            value: 'ja'
        },
        {
            label: 'Nej',
            value: 'nej'
        }
    ],
    heartsOptions: [
        {
            label: 'Ja',
            value: 'ja'
        },
        {
            label: 'Nej',
            value: 'nej'
        }
    ],
    distanceOptions: [
        {
            label: 'Ja',
            value: 'ja'
        },
        {
            label: 'Nej',
            value: 'nej'
        }
    ],
    layoutOptions: [
        {
            label: 'Stående',
            value: 'vertical'
        },
        {
            label: 'Liggande',
            value: 'horizontal'
        }
    ],
    sizeOptions: [
        {
            label: 'A4',
            value: 'a4',
        },
        {
            label: '30x40cm',
            value: '30x40cm',
        },
        {
            label: '50x70cm',
            value: '50x70cm',
        },
    ],
    presets: [
        {
            label: 'Sverige',
            value: 'sverige',
        },
        {
            label: 'Europa',
            value: 'europa1',
        },
        {
            label: 'Norden',
            value: 'europa2',
        },
        {
            label: 'Världen',
            value: 'varlden',
        },
    ],
    language: [
        {
            label: 'Svenska',
            value: 'sw',
        },
        {
            label: 'Engelska',
            value: 'en',
        },
        {
            label: 'Spanska',
            value: 'es',
        },
    ],
    heartMultiplierOptions: [
        {
            label: 'S',
            value: 0.8,
        },
        {
            label: 'M',
            value: 1,
        },
        {
            label: 'L',
            value: 2,
        },
        {
            label: 'XL',
            value: 3,
        },
        {
            label: 'XXL',
            value: 4,
        },
    ],
    iconPositionOptions: [
        {
            label: 'Top',
            value: 'top',
        },
        {
            label: 'Center',
            value: 'center',
        }
    ]
}